export enum Direction {
    UP = 'UP',
    DOWN = 'DOWN',
    RIGHT = 'RIGHT',
}
